import { gql } from '@apollo/client';

// NOTE: Only exists on api's `fdic` branch.
export const REQUEST_SALE_ACCESS = gql`
  mutation RequestSaleAccess($saleId: ID!) {
    requestSaleAccess(sale_id: $saleId) {
      __typename
      sale_id
      status
      level
      buyer_company_id
      company_name
      version
    }
  }
`;
